import type { FC } from 'react';

import { PlotSection } from '../plot-section';

import { TableSkeleton } from './TableSkeleton';

/**
 * A placeholder skeleton that mimics the table layout in OverviewTable.
 */
export const OverviewTableSkeleton: FC = () => {
  const columns = 8;
  const rows = 5;

  return (
    <PlotSection sectionName="Overview Table">
      <TableSkeleton columns={columns} rows={rows} />
    </PlotSection>
  );
};
